import { render, staticRenderFns } from "./bottomNavigation.vue?vue&type=template&id=793df9b2&"
import script from "./bottomNavigation.vue?vue&type=script&lang=js&"
export * from "./bottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./bottomNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports